import axios from '../plugins/axios.js';
import InvalidPayload from '../exceptions/InvalidPayload.js';

export default {
    async destroy(id) {
        if (!id) {
            throw new InvalidPayload('ID not provided.');
        }

        return axios.delete(`v1/leads/video-presentation/${id}`);
    },

    async videoState(id) {
        if (!id) {
            throw new InvalidPayload('ID not provided.');
        }

        const response = await axios.get(`v1/leads/video-presentation/${id}/state`);

        return response.data.data;
    },

    async update(id, payload) {
        if (!id) {
            throw new InvalidPayload('ID not provided.');
        }

        return axios.put(`v1/leads/video-presentation/${id}`, payload);
    },
};
